module.exports = __webpack_public_path__ + "static/media/br-al.9a6db96a.svg";